export default __webpack_public_path__ + "static/media/featuresMitra.3835a279.svg";